
import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface PageLayoutProps {
    children: ReactNode;
    className?: string;
}

export function PageLayout({ children, className = '' }: PageLayoutProps) {
    return (
        <div className="min-h-screen bg-navy-900 text-white selection:bg-cobalt-500/30 overflow-x-hidden">
            {/* Background Gradient Effect - Animated */}
            <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
                {/* Top Left Orb - Moves slowly */}
                <motion.div
                    animate={{
                        x: [0, 50, 0],
                        y: [0, 30, 0],
                        scale: [1, 1.1, 1],
                        opacity: [0.3, 0.5, 0.3]
                    }}
                    transition={{
                        duration: 15,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                    className="absolute -top-[10%] -left-[10%] w-[800px] h-[800px] bg-cobalt-900/20 blur-[120px] rounded-full"
                />

                {/* Bottom Right Orb - Moves slowly in opposite phase */}
                <motion.div
                    animate={{
                        x: [0, -50, 0],
                        y: [0, -40, 0],
                        scale: [1, 1.2, 1],
                        opacity: [0.2, 0.4, 0.2]
                    }}
                    transition={{
                        duration: 18,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 2
                    }}
                    className="absolute -bottom-[20%] -right-[10%] w-[600px] h-[600px] bg-cyan-900/10 blur-[100px] rounded-full"
                />

                {/* Center Accent - Very subtle pulsation */}
                <motion.div
                    animate={{
                        opacity: [0.1, 0.2, 0.1]
                    }}
                    transition={{
                        duration: 10,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-[500px] bg-gradient-to-r from-cobalt-500/5 via-transparent to-cyan-500/5 blur-[80px]"
                />
            </div>

            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="relative z-10 pt-24 md:pt-28"
            >
                {children}
            </motion.div>
        </div>
    );
}
